module.exports = __webpack_public_path__ + "static/media/guerin_logo.ed85dba6.svg";